export default defineNuxtPlugin((nuxtApp) => {
  const { log } = useDatadog()

  nuxtApp.hook('app:chunkError', (error) => {
    log('warn', {
      message: 'Chunk error occurred',
      messageContext: {
        error: {
          message: error.error.message,
          name: error.error.name,
          stack: error.error.stack,
        },
      },
    })
  })
})
